import {
  CONTACTS_REQUEST_FAIL,
  CONTACTS_REQUEST_SUCCESS,
  RESET_CONTACTS
} from '../action.types';
import initialState from '../initial.state';

export default function(state = initialState.contacts, action) {
  switch (action.type) {
    case CONTACTS_REQUEST_SUCCESS:
      return { ...action.payload };
    case CONTACTS_REQUEST_FAIL:
      return state;
    case RESET_CONTACTS:
      return initialState.contacts
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/contact/contacts.reduder.js